import { Controller } from 'stimulus';
import DOMPurify from 'dompurify';

let debounce = require('lodash/debounce');

export default class extends Controller {

  static targets = ["table", "form"]

  initialize() {
    this.searchEnterprises = debounce(this.searchEnterprises, 250).bind(this);
    this.searchRequest = null;
  }

  searchEnterprises(event) {
    if (this.searchRequest) {
      this.searchRequest.abort();
    }
    const query = event.target.value;
    this.searchRequest = $.get(`/enterprises.json${window.location.search ? window.location.search + '&' : "?"}q=${query}`).done(results => {
      const newRows = this.buildRows(results);
      this.tableTarget.innerHTML = newRows;
    }).fail(err => console.log(err));
  }

  addSiteParam() {
    const param = this.siteTarget.value;
    this.orderLinkTargets.forEach(link => {
      const path = link.getAttribute('href');
      link.setAttribute('href', `${path}&site=${param}`);
    });
  }

  submitForm() {
    this.formTarget.submit();
  }

  buildRows(results) {
    console.log(results)
    return results.map(enterprise => {
      return `
        <tr class="js-table-row"
          tabindex="0">
          <td class="cell-data cell-data--number">
            ${DOMPurify.sanitize(enterprise.id)}
          </td>
          <td class="cell-data cell-data--string">
            <a href="/admin/enterprises/${DOMPurify.sanitize(enterprise.id)}" class="action-show">
              ${DOMPurify.sanitize(enterprise.name)}
            </a>
          </td>
          <td class="cell-data cell-data--status-field">
            ${enterprise.users.length > 0 ? DOMPurify.sanitize(enterprise.users[0].name) : ""}
          </td>
          <td class="cell-data cell-data--belongs-to">
            ${this.buildSitesCell(enterprise.sites)}
          </td>
          <td class="cell-data">
            <a class="position-absolute" href="/admin/enterprises/${DOMPurify.sanitize(enterprise.id)}">
              <img class="svg-arrow"  src="/arrow_right.svg">
            </a>
          </td>
        </tr>
      `
    }).join('');
  }

  buildSitesCell(sites) {
    return sites.map(site => {
      return `<a href="/admin/sites/${site.id}">${site.name}</a>`
    }).join('\n')
  }
}
